import supportModule from '../supportModule';

const ageGateConstants = {
  maxAgeGateAge: 100,
  maxNumberOfDates: 31,
  nonLeapYear: '2014',
  birthdayPicker: {
    year: {
      id: 'YearDropdown',
      class: 'year',
      name: 'birthdayYear',
      type: 'year'
    },
    month: {
      id: 'MonthDropdown',
      class: 'month',
      name: 'birthdayMonth',
      type: 'month'
    },
    day: {
      id: 'DayDropdown',
      class: 'day',
      name: 'birthdayDay',
      type: 'day'
    }
  },
  defaultDateOrdering: {
    month: 0,
    day: 1,
    year: 2
  },
  defaultDateParts: {
    0: {
      options: [
        {
          label: 'Month',
          value: null
        }
      ],
      id: 'MonthDropdown',
      class: 'month',
      name: 'birthdayMonth',
      type: 'month'
    },
    1: {
      options: [
        {
          label: 'Day',
          value: null
        }
      ],
      id: 'DayDropdown',
      class: 'day',
      name: 'birthdayDay',
      type: 'day'
    },
    2: {
      options: [
        {
          label: 'Year',
          value: null
        }
      ],
      id: 'YearDropdown',
      class: 'year',
      name: 'birthdayYear',
      type: 'year'
    }
  }
};

supportModule.constant('ageGateConstants', ageGateConstants);

export default ageGateConstants;
